<template>
    <!-- <div class="w-full h-40px flex items-center px-[15px] cursor-pointer" @click="sa">保存</div> -->
    <div class="w-full h-40px flex items-center px-[15px] cursor-pointer" @click="dialogVisible = true">另存为</div>

    <el-dialog v-model="dialogVisible" title="另存为" width="380" append-to-body>
        <div class="cont">
            <div class="row">
                <div class="label">作品另存到：</div>
                <el-select v-model="saveSpace" class="folder-select" placeholder="选择空间" :teleported="false"
                    @change="getFolder">
                    <el-option :label="'我的空间'" value="1" />
                    <el-option :label="'团队空间'" value="2" />
                </el-select>
            </div>
            <div class="row mt-12">
                <div class="label">选择文件夹：</div>
                <el-tree-select v-model="selectedFolderId" :data="folderList" :render-after-expand="false" show-checkbox
                    check-strictly check-on-click-node node-key="folder_id"
                    :props="{ label: 'name', value: 'folder_id', children: 'children' }" :teleported="false"
                    popper-class="saveas-popper">
                    <template #default="{ data }">{{ data.name }}</template>
                </el-tree-select>
            </div>
        </div>
        <div class="footer">
            <el-button type="primary" style="background-color:#2a66ff;" @click="onConfirm">确认</el-button>
            <el-button @click="dialogVisible = false">取消</el-button>
        </div>
    </el-dialog>
</template>
<script lang="ts" setup>
import { ref, watch } from 'vue'
import { ElDialog, ElInput, ElButton, ElSelect, ElOption, ElTreeSelect, ElMessage } from 'element-plus'
import { getFolderTree, appendFileToFolder } from '@/api/affairs'
import { useSdkStore } from '@/stores/sdk'
import { resourceMove, resourceCopy } from '@/api/ResourceMasonry'
const sdkStore = useSdkStore()
const desginsdk = sdkStore.getSdk()
import { useUserStore } from '@/stores/user'
const userStore = useUserStore()
const dialogVisible = ref(false)
const saveSpace = ref('2')
const selectedFolderId = ref('')
const folderList = ref<any[]>([])

const onConfirm = async () => {
    console.log(window.location.search)
    const urlParams = new URLSearchParams(window.location.search)
    const fileId = urlParams.get('id')
    // let params = {
    //     //@ts-ignore
    //     corp_code: saveSpace.value == '1' ? "" : Auth.ins.currentTeam.corp_code,
    //     folder_id: selectedFolderId.value,
    //     file_id: fileId,
    // }
    //@ts-ignore

    let params = {
        kind: 'resource',
        to_owner_type: saveSpace.value === '1' ? 'user' : 'team',
        //@ts-ignore
        to_corp_code: saveSpace.value === '1' ? '' : userStore.currentTeamInfo.corp_id,
        to_folder_id: selectedFolderId.value || undefined,
        from_corp_code: '',
        resource_id: fileId,
        folder_id: selectedFolderId.value,
        from_owner_type: 'user',
    }
    resourceCopy(params).then(res => {
        if (res.data?.code == 200) {
            ElMessage.success('另存成功')
        } else {
            ElMessage.error(res.data?.msg || '另存失败')
        }
    })
    dialogVisible.value = false
    // console.log(Auth.ins.currentTeam
    // )
}
watch(dialogVisible, (newVal) => {
    if (newVal) {
        getFolder()
    }
})
const getFolder = () => {
    selectedFolderId.value = ''
    //@ts-ignore
    //@ts-ignore
    getFolderTree({ corp_code: saveSpace.value == '1' ? "" : userStore.currentTeamInfo.corp_id }).then(res => {
        folderList.value = res.data?.data || []
    })
}
</script>
<style lang="scss" scoped>
.cont {
    padding-top: 4px;
}

.row {
    display: flex;
    align-items: center;
    gap: 12px;
}

.label {
    width: 120px;
    font-size: 14px;
    color: #8a8f99;
}

.folder-select {
    width: 100%;
}

.mt-12 {
    margin-top: 12px;
}

.footer {
    margin-top: 16px;
    display: flex;
    justify-content: center;
    gap: 12px;
}
</style>
<style>
.saveas-popper {
    z-index: 3000 !important;
}
</style>
